/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { createIntl } from 'react-intl';
import { IntlProvider } from 'react-intl-redux';

import { Route, BrowserRouter, Switch } from 'react-router-dom';
import randomString from 'random-string';
import Logger from './Logger';
import debug from 'debug';
import RoomClient from './RoomClient';
import RoomContext from './RoomContext';
import deviceInfo from './deviceInfo';
import * as meActions from './store/actions/meActions';
import UnsupportedBrowser from './components/UnsupportedBrowser';
import ConfigDocumentation from './components/ConfigDocumentation';
import ConfigError from './components/ConfigError';
import LoginDialog from './components/AccessControl/LoginDialog';
import LoadingView from './components/Loader/LoadingView';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { persistor, store } from './store/store';
import { SnackbarProvider } from 'notistack';
import { LazyPreload } from './components/Loader/LazyPreload';
import { detectDevice } from 'mediasoup-client';
import { recorder } from './BrowserRecorder';
import InvalidURL from './components/InvalidURL';
// import loadJS from 'load-js';
import './index.css';
import './invc.css';

import { config, configError } from './config';
import LiveStreamPage from './components/Livestreaming/LiveStream';
import EndMeeting from './components/waitingRoomAndEndMeetPage/waitingRoomAndEndMeetPage';
import VideoPreview from './components/videoPreview/videoPreview';
import KickOut from './components/popups/kickOut/kickOut';
import Welcomepage from './components/webinar/welComePage/welcomepage';
import WebinarVc from './components/Livestreaming/webinarVc';
import RegistrationPage from './components/webinar/registrationPage';
import Feedback from './components/feebback/feedback';
import HostEndedWebinar from './components/hostEndedWebinar/hostEndedWebinar';
import * as settingsActions from './store/actions/settingsActions';

const App = LazyPreload(() => import(/* webpackChunkName: "app" */ './components/App'));
// const cache = createIntlCache();

const supportedBrowsers =
{
	'windows' : {
		'internet explorer' : '>12',
		'microsoft edge'    : '>18'
	},
	'safari'                       : '>12',
	// 'Safari'                      	: '',
	'firefox'                      : '>=60',
	'chrome'                       : '>=74',
	'chromium'                     : '>=74',
	'opera'                        : '>=62',
	'samsung internet for android' : '>=11.1.1.52'
};

const intl = createIntl({ locale: 'en', defaultLocale: 'en' });

recorder.intl = intl;

if (import.meta.env.VITE_DEBUG === '*' || import.meta.env.MODE !== 'production')
{
	debug.enable('* -engine* -socket* -RIE* *WARN* *ERROR*');
}

const logger = new Logger();

let roomClient;

RoomClient.init({ store });

const theme = createTheme(config.theme);

const Router = BrowserRouter;

// if (isElectron())
// 	Router = HashRouter;
// else
// 	Router = BrowserRouter;

// domready(() =>
// {
// 	logger.debug('DOM ready');

// 	// loadJS([ {
// 	// 	url : 'https://cdnjs.cloudflare.com/ajax/libs/webrtc-adapter/8.1.2/adapter.js'
// 	// } ]).then(() =>
// 	// {
// 	// eslint-disable-next-line no-console
// 	run();
// 	// });
// });
const peerId = randomString({ length: 8 }).toLowerCase();

function VcComponent()
{

	logger.debug('check peerId', peerId);

	// console.log('peerId----===', peerId);

	const urlParser = new URL(window.location);

	const hostname = urlParser.hostname;

	// const sessionId = urlParser.pathname.split('/')[1];

	const parameters = urlParser.searchParams;

	const auth = parameters.get('auth');

	const profileKey = parameters.get('profileKey');

	const lan = parameters.get('lan');

	let sipUserID = null;

	let callId;
	// if(parameters.get('peerid') != undefined) {
	// 	sessionStorage.setItem('peerid', parameters.get('peerid').slice(0,-2));
	// }else if(sessionStorage.getItem('peerid') == undefined) {
	// 	sessionStorage.setItem('peerid', window.btoa(randomString({ length: 8 }).toLowerCase()).slice(0,-2));
	// }

	// const peerId = sessionStorage.getItem('peerid');//randomString({ length: 8 }).toLowerCase();

	const accessCode = parameters.get('code');

	let produce = parameters.get('produce') !== 'false';
	const forceTcp = parameters.get('forceTcp') === 'true';

	if (parameters.get('projectId') !== undefined && parameters.get('projectId') !== null)
	{
		sessionStorage.setItem('projectId', parameters.get('projectId'));
	}

	const projectId = sessionStorage.getItem('projectId');

	// Accept both 'uid' and 'userId' URL params — some clients send userId instead of uid
	const uidParam = parameters.get('uid');

	if (uidParam !== undefined && uidParam !== null)
	{
		sessionStorage.setItem('uid', uidParam);
		try
		{
			if (atob(uidParam) !== 'guest')
			{
				store.dispatch(settingsActions.setDisplayEmail(atob(uidParam)));
			}
		}
		catch (err)
		{
			store.dispatch(settingsActions.setDisplayEmail(uidParam));
		}
	}

	if (parameters.get('sipUserID') !== undefined && parameters.get('sipUserID') !== null)
	{
		sipUserID = atob(parameters.get('sipUserID'));
	}

	if (parameters.get('callId') !== undefined || parameters.get('callId') !== null)
	{
		callId = atob(parameters.get('callId'));
	}

	const _uid = sessionStorage.getItem('uid');

	if (parameters.get('displayName') !== undefined && parameters.get('displayName') !== null)
	{
		sessionStorage.setItem('displayName', parameters.get('displayName'));
	}

	const displayName = sessionStorage.getItem('displayName');

	if (parameters.get('meetingType') !== undefined && parameters.get('meetingType') !== null)
	{
		sessionStorage.setItem('meetingType', window.atob(parameters.get('meetingType')));
	}

	if (parameters.get('auth') !== undefined && parameters.get('auth') !== null)
	{
		sessionStorage.setItem('auth', auth);
	}

	if (parameters.get('profileKey') && parameters.get('profileKey') !== undefined && parameters.get('profileKey') !== null)
	{
		sessionStorage.setItem('profileKey', profileKey);
	}

	const getProfile = sessionStorage.getItem('profileKey');

	if (getProfile)
	{
		store.dispatch(meActions.setPicture(getProfile));
	}

	if (parameters.get('lan') && parameters.get('lan') !== undefined && parameters.get('lan') !== null)
	{
		sessionStorage.setItem('lan', lan);
	}

	const getLan = sessionStorage.getItem('lan');

	if (getLan)
	{
		store.dispatch(meActions.setLanguage(getLan));
		// roomClient.setLocale(getLan, 'key');
	}

	if (parameters.get('pairId') !== undefined && parameters.get('pairId') !== null)
	{
		sessionStorage.setItem('pairId', parameters.get('pairId'));
	}

	const pairId = sessionStorage.getItem('pairId');

	console.log('parameters.get()', parameters.get('presenceUserId'));

	if (parameters.get('presenceUserId') !== undefined && parameters.get('presenceUserId') !== null)
	{
		sessionStorage.setItem('presenceUserId', parameters.get('presenceUserId'));
	}

	const presenceUserId = sessionStorage.getItem('presenceUserId');

	console.log('presenceUserIdpresenceUserIdpresenceUserId', presenceUserId);

	const meetingType = sessionStorage.getItem('meetingType');

	const screenPage = Number(parameters.get('screen'));
	const mode = parameters.get('mode');
	const mDeviceId = parameters.get('mDeviceId');
	const mDeviceType = parameters.get('mDeviceType');
	const record = parameters.get('record') === 'true';

	if (screenPage || record || (mode && (mode === 'speaker' || mode === 'screen')))
	{
		produce = false;
	}

	const muted = parameters.get('muted') === 'true';
	const headless = parameters.get('headless');
	const showConfigDocumentationPath = parameters.get('config') === 'true';

	const { pathname } = window.location;

	// const emptyCache = () =>
	// {
	// 	if ('caches' in window)
	// 	{
	// 		console.log('cache cleared');
	// 		caches.keys().then((names) =>
	// 		{
	// 		// Delete all the cache files
	// 			names.forEach((name) =>
	// 			{
	// 				caches.delete(name);
	// 			});
	// 		});
	// 		// Makes sure the page reloads. Changes are only visible after you refresh.
	// 		// window.location.reload(true);
	// 	}
	// };

	let basePath = pathname.substring(0, pathname.lastIndexOf('/'));

	if (!basePath && !(pathname === '/welcome'))
	{
		basePath = '/';
	}

	const isInvalidURL = false;

	// if (parameters.get('token') !== undefined && parameters.get('token') !== null)
	// {
	// 	sessionStorage.setItem('token', parameters.get('token'));
	// }

	// const token = sessionStorage.getItem('token');

	// if (!token)
	// {
	// 	// isInvalidURL = true;
	// 	// window.location = `https://${config.appURL}/inconf${window.location.pathname}`;
	// }
	// Get current device.
	const device = deviceInfo();

	if (device.network)
	{
		store.dispatch(settingsActions.setNetwork(device.network));
	}
	const fetchIpAddress = async () =>
	{
		try
		{
			const response = await fetch(import.meta.env.VITE_LOCATION_CLOUDFRONT_URL);
			const data = await response.json();

			store.dispatch(settingsActions.setIP(data.ip));
			store.dispatch(settingsActions.setCountryName(data.countryName));
			store.dispatch(settingsActions.setCountryCode(data.country));
		}
		catch (error)
		{
			console.error('Error fetching IP address:', error);
		}
	};

	fetchIpAddress();

	// const fetchCountryName = async () =>
	// {
	// 	try
	// 	{
	// 		const res = await axios.get('https://ipapi.co/json/');

	// 		store.dispatch(settingsActions.setCountryName(res?.data.country_name));
	// 		store.dispatch(settingsActions.setCountryCode(res?.data?.country_code));
	// 	}
	// 	catch (error)
	// 	{
	// 		console.log('error getting country==', error);
	// 	}

	// };

	// fetchCountryName();

	let unsupportedBrowser = false;

	let webrtcUnavailable = false;

	if (device.platform === 'desktop' && device.name === 'electron')
	{
		unsupportedBrowser = false;
	}
	else if (detectDevice() === undefined)
	{
		logger.error('Your browser is not supported [deviceInfo:"%o"]', device);

		unsupportedBrowser = true;
	}
	else if (
		navigator.mediaDevices === undefined ||
		navigator.mediaDevices.getUserMedia === undefined ||
		window.RTCPeerConnection === undefined
	)
	{
		logger.error('Your browser is not supported [deviceInfo:"%o"]', device);

		// eslint-disable-next-line no-console

		// if (device.bowser && device.bowser && device.bowser.parsedResult.browser.name === 'Safari')
		// {
		// 	webrtcUnavailable = false;
		// 	// eslint-disable-next-line no-console

		// }
		// else
		// {
		webrtcUnavailable = true;
		// }

	}
	else if (
		!device.bowser.satisfies(
			config.supportedBrowsers || supportedBrowsers
		)
	)
	{
		// eslint-disable-next-line no-console

		logger.error(
			'Your browser is not supported [deviceInfo:"%o"]',
			device
		);

		unsupportedBrowser = true;
	}
	else
	{
		logger.debug('Your browser is supported [deviceInfo:"%o"]', device);
	}

	// if (urlParser.pathname.includes('live'))
	// {
	// 	// eslint-disable-next-line no-console

	// 	render(
	// 		<Provider store={store}>
	// 			<MuiThemeProvider theme={theme}>
	// 				<IntlProvider value={intl}>
	// 					<LiveStreamPage />
	// 				</IntlProvider>
	// 			</MuiThemeProvider>
	// 		</Provider>,
	// 		document.getElementById('_invc')
	// 	);

	// 	return;
	// }

	if (unsupportedBrowser || webrtcUnavailable)
	{
		const container = document.getElementById('_invc');
		const root = createRoot(container);
		root.render(
			<Provider store={store}>
				<ThemeProvider theme={theme}>
					<IntlProvider value={intl}>
						<UnsupportedBrowser
							webrtcUnavailable={webrtcUnavailable}
							platform={device.platform}
						/>
					</IntlProvider>
				</ThemeProvider>
			</Provider>
		);

		return;
	}

	if (showConfigDocumentationPath)
	{
		const container = document.getElementById('_invc');
		const root = createRoot(container);
		root.render(
			<Provider store={store}>
				<ThemeProvider theme={theme}>
					<IntlProvider value={intl}>
						<ConfigDocumentation />
					</IntlProvider>
				</ThemeProvider>
			</Provider>
		);

		return;
	}

	if (configError)
	{
		const container = document.getElementById('_invc');
		const root = createRoot(container);
		root.render(
			<Provider store={store}>
				<ThemeProvider theme={theme}>
					<IntlProvider value={intl}>
						<ConfigError configError={configError} />
					</IntlProvider>
				</ThemeProvider>
			</Provider>
		);

		return;
	}

	// if (sessionId && sessionId !== 'live')
	// {
	// 	const { sessionResponse, time } = await endSession(sessionId, projectId);

	// 	if (sessionResponse)
	// 	{
	// 		render(
	// 			<Provider store={store}>
	// 				<MuiThemeProvider theme={theme}>
	// 					<IntlProvider value={intl}>
	// 						<SessionExpired time={time} />
	// 					</IntlProvider>
	// 				</MuiThemeProvider>
	// 			</Provider>,
	// 			document.getElementById('_invc')
	// 		);

	// 		return;
	// 	}
	// }

	// eslint-disable-next-line no-console

	// eslint-disable-next-line no-console

	// if (projectId)
	// {
	// 	const templateData = await getBrandingImage(projectId);

	// 	if (templateData && templateData !== null)
	// 	{
	// 		// eslint-disable-next-line max-len
	// 		if (((window.location && window.location.ancestorOrigins && window.location.ancestorOrigins[0]) || window.document.referrer) && templateData.data && templateData.data.data && templateData.data.data.whitelistUrls && templateData.data.data.whitelistUrls.length > 0)
	// 		{
	// 			// eslint-disable-next-line no-console

	// 			let allowUrl;

	// 			if (window.location.ancestorOrigins && window.location.ancestorOrigins[0])
	// 			{
	// 				// eslint-disable-next-line no-console
	// 				// eslint-disable-next-line max-len
	// 				allowUrl = templateData.data.data.whitelistUrls.indexOf(window.location.ancestorOrigins[0]) !== -1;
	// 			}
	// 			else if (window.document.referrer)
	// 			{
	// 				// eslint-disable-next-line no-console
	// 				let link;

	// 				if (window.document.referrer.charAt(window.document.referrer.length-1) === '/')
	// 				{
	// 					// eslint-disable-next-line max-len
	// 					link = window.document.referrer.substring(0, window.document.referrer.length-1);
	// 				}
	// 				else
	// 				{
	// 					link = window.document.referrer;
	// 				}
	// 				// eslint-disable-next-line no-console
	// 				// eslint-disable-next-line max-len
	// 				allowUrl = templateData.data.data.whitelistUrls.indexOf(link) !== -1;
	// 			}
	// 			// eslint-disable-next-line max-len
	// 			// allowUrl = ((templateData.data.data.whitelistUrls.indexOf(window.location.ancestorOrigins[0]) !== -1) || (templateData.data.data.whitelistUrls.indexOf(window.document.referrer) !== -1));

	// 			// eslint-disable-next-line no-console
	//
	// 			if (!allowUrl)
	// 			{
	// 				// eslint-disable-next-line no-console

	// 				if (window.location.ancestorOrigins&& window.location.ancestorOrigins[0])
	// 				{
	// 					// eslint-disable-next-line no-console
	// 					// eslint-disable-next-line no-alert
	// 					alert('Unauthorised!');
	// 				// window.location.replace(window.location.ancestorOrigins[0]);
	// 				}
	// 				else if (window.document.referrer)
	// 				{
	// 					// eslint-disable-next-line no-console
	// 					// eslint-disable-next-line no-alert
	// 					alert('Unauthorised!');
	// 				// window.location.replace(window.document.referrer);
	// 				}
	// 				else
	// 				{
	// 				// eslint-disable-next-line no-alert
	// 					alert('Unauthorised!');
	// 				}

	// 				return;
	// 			}
	// 		}
	// 		else
	// 		{

	// 			const subD = window.location.hostname.split('.')[0];

	// 			// eslint-disable-next-line no-console

	// 			if (subD !== templateData.data.data.subDomain)
	// 			{
	// 			// eslint-disable-next-line no-alert
	// 				alert('Invalid Meeting!');
	// 				// window.location.replace('https://onpassive.com');

	// 				return;
	// 			}
	// 		}
	// 	}
	// 	else
	// 	{
	// 		// eslint-disable-next-line no-alert
	// 		alert('Invalid Meeting!');

	// 		return;
	// 	}
	// }

	console.log('peer id in vc component===', peerId);

	store.dispatch(
		meActions.setMe({
			peerId,
			loginEnabled : config.loginEnabled
		})
	);

	if (!window.CLIENT)
	{
		roomClient = new RoomClient(
			{
				peerId,
				accessCode,
				device,
				produce,
				headless,
				forceTcp,
				displayName,
				muted,
				basePath,
				// token,
				projectId,
				screenPage,
				mDeviceId,
				mDeviceType,
				record,
				_uid,
				hostname,
				meetingType,
				pairId,
				getLan,
				mode,
				sipUserID,
				callId,
				presenceUserId
			});
	}
	else
	{
		roomClient = window.CLIENT;
	}

	global.CLIENT = roomClient;

	return (
		<Provider store={store}>
			<ThemeProvider theme={theme}>
				<IntlProvider value={intl}>
					<PersistGate loading={<LoadingView />} persistor={persistor}>
						<RoomContext.Provider value={roomClient}>
							<SnackbarProvider>
								<Router basename={basePath}>
									<Suspense fallback={<LoadingView />}>
										<React.Fragment>
											<Switch color='primary'>
												{/* <Route exact path='/' component={DesktopRoomsPlugins} />
												<Route exact path='/desktop_room' component={ConferenceRoom} /> */}
												{(!(device.platform === 'desktop' && device.name === 'electron') || (sipUserID === null || sipUserID === undefined)) && <Route exact path='/' component={VideoPreview} />}
												{/* <Route exact path='/' component={JoinDialogNew} /> */}

												<Route exact path='/live' component={LiveStreamPage} />
												<Route exact path='/register' component={RegistrationPage} />
												<Route exact path='/join-webinar' component={WebinarVc} />
												<Route exact path='/welcome' component={Welcomepage} />
												<Route exact path='/endMeeting' component={EndMeeting}/>
												<Route exact path='/kickOut' component={KickOut}/>
												<Route exact path='/login_dialog' component={LoginDialog} />
												<Route exact path='/feedback' component={Feedback}/>
												<Route exact path='/hostEndedWebinar' component={HostEndedWebinar}/>

												{isInvalidURL ?
													<Route path='/:id' component={InvalidURL} />
													:
													<Route path='/:id' component={App} />}
											</Switch>
										</React.Fragment>
									</Suspense>
								</Router>
							</SnackbarProvider>
						</RoomContext.Provider>
					</PersistGate>
				</IntlProvider>
			</ThemeProvider>
		</Provider>
	);
}

// serviceWorker.unregister();

export default VcComponent;
